import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ExpandButtonService {
    overlap$ = new BehaviorSubject<boolean>(true);

    constructor() {}
}
